import React, { useEffect, useState } from "react";
import { DEFAULT_EXPLORE_CATEGORIES } from "../config/categoryPresentation";
import ClaimVenueSheet from "./ClaimVenueSheet";

const DEFAULT_BACKEND =
  (typeof window !== "undefined" && window.__PARTY_BACKEND__) ||
  "https://partybutton-private-a027fa6fce78.herokuapp.com";

export default function ExploreSheet({
  categories,
  onPickCategory,
  neighborhoods,
  marketName = "San Francisco",
  isBetaMarket = false,
  features = {},
  selectedNeighborhood,
  onPickNeighborhood,
  onClearNeighborhood,
  onOpenPartyQuest,
  onOpenEvents,
  featuredArtist,
  backendBase,
  partyUid,
  selectedVenue,
  onOpenUrl,
  onClaimSubmitted,
  onClose,
}) {
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [artistOpen, setArtistOpen] = useState(false);
  const [claimOpen, setClaimOpen] = useState(false);
  const [neighborhoodsOpen, setNeighborhoodsOpen] = useState(false);
  const [showAllNeighborhoods, setShowAllNeighborhoods] = useState(false);


  const openUrl = (url) => {
    if (!url) return;
    if (typeof onOpenUrl === "function") return onOpenUrl(url);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getVenueId = (v) => v?.place_id || v?.placeId || v?.id || null;

  const items = categories || DEFAULT_EXPLORE_CATEGORIES;
  // PB_OAKLAND_BETA_UI_COPY_V1
  // PB_OAKLAND_FEATURE_GATES_V1: market extras are opt-in.
  const areaLabel = `${marketName}${isBetaMarket ? " beta" : ""}`;
  const neighborhoodItems = Array.isArray(neighborhoods) ? neighborhoods : [];
  const primaryNeighborhoods = neighborhoodItems.slice(0, 6);
  const visibleNeighborhoods = showAllNeighborhoods
    ? neighborhoodItems
    : selectedNeighborhood && !primaryNeighborhoods.includes(selectedNeighborhood)
      ? [...primaryNeighborhoods, selectedNeighborhood]
      : primaryNeighborhoods;

  useEffect(() => {
    setCategoriesOpen(true);
  }, []);

  useEffect(() => {
    const anyOpen = categoriesOpen || artistOpen || claimOpen;
    if (!anyOpen) return;

    const onKeyDown = (e) => {
    if (e.key === "Escape") {
  closeAll();
}
    };

    window.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [categoriesOpen, artistOpen, claimOpen]);




const closeAll = () => {
  setCategoriesOpen(false);
  setArtistOpen(false);
  setClaimOpen(false);
  onClose?.();
};
  const pickCategory = (key) => {
    try {
      onPickCategory?.(key);
    } finally {
  closeAll();
}
  };

  const pickNeighborhood = (name) => {
    try {
      onPickNeighborhood?.(name);
    } finally {
      closeAll();
    }
  };

  const clearNeighborhood = () => {
    try {
      onClearNeighborhood?.();
    } finally {
      closeAll();
    }
  };

  const hasArtist = !!(
    featuredArtist?.title ||
    featuredArtist?.subtitle ||
    (featuredArtist?.links || []).length
  );

  const placeId = getVenueId(selectedVenue);
  const hasVenue = !!placeId;

  const openArtistPanel = () => {
    setCategoriesOpen(false);
    setClaimOpen(false);
    setArtistOpen(true);
  };

  const openClaimPanel = () => {
    if (!hasVenue) return;
    setCategoriesOpen(false);
    setArtistOpen(false);
    setClaimOpen(true);
  };

  return (
    <>
      {categoriesOpen && (
        <div
          className="pb-sheet-backdrop"
          role="dialog"
          aria-modal="true"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeAll();
          }}
        >
  <div className="pb-sheet" onClick={(e) => e.stopPropagation()}>
  <div className="pb-sheet-handle" />

  <div className="pb-sheet-header">
    <div className="pb-sheet-title">Explore</div>
  </div>

  <div className="pb-sheet-grid">
              {items.map((c) => (
                <button
                  key={c.key}
                  className="pb-sheet-item"
                  type="button"
                  onClick={() => pickCategory(c.key)}
                >
                  <span className="pb-sheet-emoji">{c.emoji || "✨"}</span>
                  <span className="pb-sheet-label">{c.label}</span>
                </button>
              ))}
            </div>

            <div className="pb-neighborhood-section">
              <button
                className={`pb-neighborhood-toggle ${selectedNeighborhood ? "is-active" : ""}`}
                type="button"
                aria-expanded={neighborhoodsOpen}
                onClick={() => setNeighborhoodsOpen((open) => !open)}
              >
                <span className="pb-sheet-action-icon" aria-hidden="true">📍</span>
                <span className="pb-neighborhood-toggle-copy">
                  <strong>{selectedNeighborhood || "Neighborhoods"}</strong>
                  <small>
                    {selectedNeighborhood
                      ? "Browsing this neighborhood — tap to change"
                      : `Browse ${areaLabel} by area`}
                  </small>
                </span>
                <span
                  className={`pb-neighborhood-chevron ${neighborhoodsOpen ? "is-open" : ""}`}
                  aria-hidden="true"
                />
              </button>

              {neighborhoodsOpen && (
                <div className="pb-neighborhood-panel">
                  <div className="pb-neighborhood-chips" aria-label={`${marketName} neighborhoods`}>
                    {visibleNeighborhoods.map((name) => (
                      <button
                        key={name}
                        className={`pb-neighborhood-chip ${selectedNeighborhood === name ? "is-selected" : ""}`}
                        type="button"
                        onClick={() => pickNeighborhood(name)}
                      >
                        {name}
                      </button>
                    ))}
                  </div>

                  {neighborhoodItems.length > primaryNeighborhoods.length ? (
                    <button
                      className="pb-neighborhood-more"
                      type="button"
                      onClick={() => setShowAllNeighborhoods((show) => !show)}
                    >
                      {showAllNeighborhoods ? "Show fewer" : "More neighborhoods…"}
                    </button>
                  ) : null}

                  {selectedNeighborhood ? (
                    <button
                      className="pb-neighborhood-clear"
                      type="button"
                      onClick={clearNeighborhood}
                    >
                      × Clear {selectedNeighborhood}
                    </button>
                  ) : null}
                </div>
              )}
            </div>

            <div className="pb-sheet-actions" aria-label="Explore more">
              {features.partyQuest === true && (
                <button
                  className="pb-sheet-action pb-quest-action"
                  type="button"
                  onClick={() => {
                    closeAll();
                    onOpenPartyQuest?.();
                  }}
                >
                  <span
                    className="pb-sheet-action-icon"
                    aria-hidden="true"
                  >
                    🎯
                  </span>

                  <span>
                    <strong>Party Quest</strong>
                    <small>
                      Play a neighborhood adventure
                    </small>
                  </span>
                </button>
              )}

              {features.events === true && (
                <button
                  className="pb-sheet-action pb-events-action"
                  type="button"
                  onClick={() => {
                    closeAll();
                    onOpenEvents?.();
                  }}
                >
                  <span
                    className="pb-sheet-action-icon"
                    aria-hidden="true"
                  >
                    🔥
                  </span>

                  <span>
                    <strong>Happening Tonight</strong>
                    <small>
                      Events across San Francisco neighborhoods
                    </small>
                  </span>
                </button>
              )}

              {hasArtist ? (
                <button
                  className="pb-sheet-action"
                  type="button"
                  onClick={openArtistPanel}
                >
                  <span className="pb-sheet-action-icon" aria-hidden="true">🎨</span>
                  <span>
                    <strong>Featured Artist</strong>
                    <small>Apply for a photo takeover</small>
                  </span>
                </button>
              ) : null}

              <button
                className="pb-sheet-action"
                type="button"
                onClick={openClaimPanel}
                disabled={!hasVenue}
              >
                <span className="pb-sheet-action-icon" aria-hidden="true">🏪</span>
                <span>
                  <strong>Business Owner Photo</strong>
                  <small>
                    {hasVenue
                      ? `Submit a photo for ${selectedVenue?.name || 'this venue'}`
                      : 'Select a venue first'}
                  </small>
                </span>
              </button>
            </div>

            <div className="pb-sheet-footer">
              <button
                className="pb-sheet-secondary"
                onClick={() => closeAll()}
                type="button"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {artistOpen && (
        <div
          className="pb-sheet-backdrop"
          role="dialog"
          aria-modal="true"
          onClick={() => closeAll()}
        >
          <div className="pb-sheet" onClick={(e) => e.stopPropagation()}>
           <div className="pb-sheet-handle" />

<div className="pb-sheet-header">
  <div className="pb-sheet-title">Featured Artist</div>
  <button
    className="pb-sheet-close"
    onClick={() => closeAll()}
    type="button"
  >
    ✕
  </button>
</div>

<div className="pb-sheet-body">
              <div className="pb-artist-title">
                {featuredArtist?.title || "Featured"}
              </div>
              {featuredArtist?.subtitle && (
                <div className="pb-artist-sub">{featuredArtist.subtitle}</div>
              )}

              {(featuredArtist?.links || []).length > 0 && (
                <div className="pb-artist-links">
                  {(featuredArtist.links || []).map((l, idx) => (
                    <button
                      key={idx}
                      type="button"
                      className="pb-artist-link"
                      onClick={() => openUrl(l?.url)}
                      disabled={!l?.url}
                    >
                      {l?.label || l?.url || "Link"}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="pb-sheet-footer">
              <button
                className="pb-sheet-secondary"
                onClick={() => closeAll()}
                type="button"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ClaimVenueSheet
        open={claimOpen}
        venue={selectedVenue}
        backendBase={backendBase || DEFAULT_BACKEND}
        partyUid={partyUid}
        onClose={() => closeAll()}
        onSubmitted={(claim) => onClaimSubmitted?.(selectedVenue, claim)}
      />

      <style>{`
        .pb-sheet-backdrop{
          position:fixed;
          inset:0;
          background: rgba(0,0,0,0.35);
          display:flex;
          justify-content:center;
          align-items:flex-end;
          z-index:9999;
          padding: 10px;
          padding-bottom: calc(10px + env(safe-area-inset-bottom));
        }

        .pb-sheet{
          width: min(720px, 100%);
          background: rgba(255,255,255,0.92);
          backdrop-filter: blur(14px);
          border-top-left-radius: 22px;
          border-top-right-radius: 22px;
          box-shadow: 0 -12px 30px rgba(0,0,0,0.18);
          overflow:hidden;
          border: 1px solid rgba(0,0,0,0.08);
        }
        .pb-sheet-tall{ max-height: 86vh; }

        .pb-sheet-handle{
          width: 58px;
          height: 6px;
          border-radius: 6px;
          background: rgba(0,0,0,0.16);
          margin: 10px auto 2px auto;
        }

        .pb-sheet-header{
          display:flex;
          align-items:center;
          justify-content:space-between;
          padding: 10px 14px 6px 14px;
        }
        .pb-sheet-title{
          font-size: 18px;
          font-weight: 800;
        }
        .pb-sheet-close{
          border:0;
          background: rgba(0,0,0,0.06);
          border-radius: 12px;
          padding: 8px 10px;
          cursor:pointer;
          font-weight:800;
        }

        .pb-sheet-grid{
          display:grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          padding: 12px 14px 14px 14px;
        }
        @media (min-width: 560px){
          .pb-sheet-grid{ grid-template-columns: repeat(4, 1fr); }
        }

        .pb-sheet-item{
          display:flex;
          align-items:center;
          gap:10px;
          border: 1px solid rgba(0,0,0,0.08);
          background: linear-gradient(90deg, rgba(255,105,180,0.18), rgba(64,224,208,0.18));
          border-radius: 16px;
          padding: 14px 12px;
          cursor:pointer;
        }
        .pb-sheet-emoji{ font-size: 20px; }
        .pb-sheet-label{ font-size: 16px; font-weight: 800; }

        .pb-sheet-body{ padding: 12px 14px 14px 14px; }

        .pb-neighborhood-section{
          padding: 0 14px 14px;
        }
        .pb-neighborhood-toggle{
          width:100%;
          display:flex;
          align-items:center;
          gap:11px;
          text-align:left;
          border:1px solid rgba(0,0,0,0.09);
          background:rgba(255,255,255,0.78);
          border-radius:16px;
          padding:12px;
          cursor:pointer;
        }
        .pb-neighborhood-toggle.is-active{
          border-color:rgba(213,27,145,.28);
          background:linear-gradient(90deg, rgba(255,105,180,.15), rgba(64,224,208,.12));
        }
        .pb-neighborhood-toggle-copy{
          display:flex;
          flex:1;
          min-width:0;
          flex-direction:column;
        }
        .pb-neighborhood-toggle-copy strong{ font-size:15px; }
        .pb-neighborhood-toggle-copy small{
          margin-top:2px;
          font-size:12px;
          font-weight:800;
          opacity:.65;
        }
        .pb-neighborhood-chevron{
          flex:0 0 auto;
          width:9px;
          height:9px;
          margin-right:3px;
          border-right:2px solid currentColor;
          border-bottom:2px solid currentColor;
          transform:rotate(45deg);
          opacity:.55;
          transition:transform .18s ease;
        }
        .pb-neighborhood-chevron.is-open{
          transform:rotate(225deg);
        }
        .pb-neighborhood-panel{
          margin-top:9px;
          padding:10px;
          border-radius:14px;
          background:rgba(255,255,255,.58);
          border:1px solid rgba(0,0,0,.07);
        }
        .pb-neighborhood-chips{
          display:flex;
          flex-wrap:wrap;
          gap:7px;
        }
        .pb-neighborhood-chip{
          border:1px solid rgba(0,0,0,.10);
          background:rgba(255,255,255,.84);
          border-radius:999px;
          padding:8px 11px;
          font-size:13px;
          font-weight:850;
          cursor:pointer;
        }
        .pb-neighborhood-chip.is-selected{
          color:#fff;
          border-color:transparent;
          background:linear-gradient(90deg, rgba(213,27,145,.96), rgba(64,180,180,.96));
        }
        .pb-neighborhood-more,
        .pb-neighborhood-clear{
          margin-top:9px;
          border:0;
          background:transparent;
          padding:3px 2px;
          font-size:12px;
          font-weight:900;
          cursor:pointer;
        }
        .pb-neighborhood-more{ color:#555; margin-right:14px; }
        .pb-neighborhood-clear{ color:#b01876; }

        .pb-sheet-actions{
          display:grid;
          gap:10px;
          padding:0 14px 14px;
        }
        .pb-sheet-action{
          width:100%;
          display:flex;
          align-items:center;
          gap:11px;
          text-align:left;
          border:1px solid rgba(0,0,0,0.09);
          background:rgba(255,255,255,0.78);
          border-radius:16px;
          padding:12px;
          cursor:pointer;
        }
        .pb-sheet-action > span:last-child{
          display:flex;
          flex-direction:column;
          min-width:0;
        }
        .pb-sheet-action strong{ font-size:15px; }
        .pb-sheet-action small{
          margin-top:2px;
          font-size:12px;
          font-weight:800;
          opacity:.65;
        }
        .pb-sheet-action-icon{ font-size:22px; flex:0 0 auto; }
        .pb-sheet-action:disabled{ opacity:.48; cursor:not-allowed; }

        .pb-quest-action{
          color:#fff;
          border-color:rgba(59,130,246,.30);
          background:
            linear-gradient(
              100deg,
              rgba(236,72,153,.96),
              rgba(37,99,235,.94)
            );
          box-shadow:
            0 8px 20px rgba(37,99,235,.18);
        }

        .pb-quest-action small{
          color:rgba(255,255,255,.82);
          opacity:1;
        }

        .pb-events-action{
          color:#fff;
          border-color:rgba(236,72,153,.28);
          background:
            linear-gradient(
              100deg,
              rgba(236,72,153,.96),
              rgba(139,92,246,.94)
            );
          box-shadow:
            0 8px 20px rgba(139,92,246,.18);
        }

        .pb-events-action small{
          color:rgba(255,255,255,.78);
          opacity:1;
        }

        .pb-sheet-footer{ padding: 0 14px 14px 14px; }
        .pb-sheet-secondary{
          width:100%;
          border: 1px solid rgba(0,0,0,0.10);
          background: rgba(255,255,255,0.75);
          border-radius: 16px;
          padding: 12px;
          font-size: 16px;
          font-weight: 800;
          cursor:pointer;
        }

        .pb-rail-btn{
          width:100%;
          border:0;
          border-radius:16px;
          padding:14px 12px;
          font-size:16px;
          font-weight:700;
          color:#fff;
          cursor:pointer;
          background: linear-gradient(90deg, rgba(255,105,180,0.95), rgba(64,224,208,0.95));
          box-shadow: 0 6px 16px rgba(0,0,0,0.10);
          text-align:center;
        }
        .pb-rail-btn:disabled{ cursor:not-allowed; }

        .pb-artist-title{ font-size: 18px; font-weight: 900; }
        .pb-artist-sub{ margin-top: 6px; font-weight: 800; opacity: 0.75; }
        .pb-artist-links{ margin-top: 12px; display:flex; flex-direction:column; gap:10px; }
        .pb-artist-link{
          width:100%;
          border: 1px solid rgba(0,0,0,0.10);
          background: rgba(255,255,255,0.75);
          border-radius: 16px;
          padding: 12px;
          font-size: 15px;
          font-weight: 900;
          cursor:pointer;
        }
        .pb-artist-link:disabled{ opacity:0.6; cursor:not-allowed; }
      `}</style>
    </>
  );
}
